import { BaseElectionPost } from "./base/BaseElectionPost";
import {
  formatWithCommas, 
  roundToTwoDecimals, 
  convertirFecha 
} from "../utils/dataFormatter";

export class JefeGobiernoPost extends BaseElectionPost {
  constructor() {
    super({
      electionType: 'jefeGobierno',
      thresholds: { low: 5, medium: 25, high: 50 }
    });
  }

  /**
   * ALTERNATIVA 0: Post inicial (0-5% escrutado)
   */
  createInitialContent(data, params) {
    const fechasFormateadas = convertirFecha(data.last_update);
    const localidadText = data.localidad ? `en ${data.localidad}` : '';

    return {
      title: `Elecciones 2023: aguardando resultados para Jefe de Gobierno en CABA ${localidadText}`,
      summary: `
        <ul>
          <li>Las urnas cerraron en la Ciudad de Buenos Aires.</li>
          <li>Los primeros datos del escrutinio se conocerán en las próximas horas.</li>
        </ul>`,
      subtitle: "",
      description: "",
      publishedDate: "2023-10-22T19:05:00.000Z",
      formattedPublishedDate: "22 OCT 2023",
      lastModified: "Sun, 22 Oct 2023 19:05:00 GMT",
      gtmPublishedDate: "2023-10-22T",
      modificatedAt: fechasFormateadas,
      body: [
        {
          type: "text",
          value: `<p>Las urnas cerraron en la Ciudad de Buenos Aires y el escrutinio provisorio para la elección a Jefe de Gobierno comenzó. Los primeros datos oficiales se esperan en las próximas horas a medida que avance el conteo de votos.</p>`
        },
        {
          type: "text",
          value: `<p>En paralelo a las elecciones para Presidente y Jefe de Gobierno, los porteños también eligieron 30 legisladores de la Ciudad (se renueva la mitad de la Legislatura) y las 15 Juntas Comunales.</p>`
        },
        {
          type: "text",
          value: `<p>Esta página se actualizará automáticamente con los resultados oficiales en tiempo real.</p>`
        },
        {
          _id: "iframe-map",
          type: "freehtml",
          value: {
            title: null,
            summary: null,
            name: `Mapa electoral - Jefe de Gobierno CABA`,
            html: `<iframe class="elections-iframe" src="${params.urlIframe}" title="Resultados Jefe de Gobierno CABA" scrolling="no" frameborder="0" data-external="1"></iframe>
              <script type="text/javascript" src="https://ecp.clarin.com/demo/js/iframeResizer.min.js"></script>
              <script type="text/javascript">iFrameResize({checkOrigin:false,heightCalculationMethod:'documentElementOffset',});</script>`,
            htmlAmp: null
          }
        },
        ...this.getRelatedLinks()
      ],
      authors: [],
      sections: this.getSections(),
      metadata: this.getMetadata()
    };
  }

  /**
   * ALTERNATIVA 1: Post temprano (5-25% escrutado)
   */
  createEarlyContent(data, params) {
    this.formatCandidates(data);
    const votosEnBlanco = this.extractStats(data.stats, "blank");
    const votosNulos = this.extractStats(data.stats, "annulled");
    const fechasFormateadas = convertirFecha(data.last_update);
    const localidadText = data.localidad ? `en la ${data.localidad}` : '';

    return {
      title: `Resultados Elecciones 2023 en CABA: quién es el candidato a Jefe de Gobierno más votado ${localidadText}`,
      summary: `
        <ul>
          <li>Quién gana los comicios en la Ciudad de Buenos Aires este domingo 22 de octubre.</li>
          <li>Toda la información actualizada y el mapa electoral, minuto a minuto.</li>
        </ul>`,
      subtitle: "",
      description: "",
      publishedDate: "2023-10-22T19:05:00.000Z",
      formattedPublishedDate: "18 SEP 2023",
      lastModified: "Mon, 18 Sep 2023 23:01:20 GMT",
      gtmPublishedDate: "2023-09-18T",
      modificatedAt: fechasFormateadas,
      body: [
        {
          type: "text",
          value: `<p>Con el <strong>${data.mesasEscrutadas}%</strong> de mesas escrutadas en el marco de las Elecciones 2023 desarrolladas este
            domingo en la Ciudad de Buenos Aires (CABA), el candidato a jefe de Gobierno porteño más votado ${data.localidad ? `en la <strong>${data.localidad}</strong>` : ''} 
            era <strong>${data.ganador.candidates[0].fullname}</strong>, de <strong>${data.ganador.name}</strong>, quien obtenía <strong>${data.ganador.votes}</strong>
            votos, lo que representa el <strong>${data.ganador.votes_percent}</strong> por ciento de los votos.</p>`
        },
        {
          type: "text",
          value: `<p>En segundo lugar en CABA se encontraba <strong>${data.segundo.candidates[0].fullname}</strong>, de <strong>${data.segundo.name}</strong>, 
            con <strong>${data.segundo.votes}</strong> votos, logrando el <strong>${data.segundo.votes_percent}</strong> 
            por ciento de los sufragios, mientras que en la tercera posición se encontraba <strong>${data.tercero.candidates[0].fullname}</strong>, de <strong>${data.tercero.name}</strong>, 
            con <strong>${data.tercero.votes}</strong> votos (<strong>${data.tercero.votes_percent}</strong> por ciento).</p>`
        },
        {
          type: "text",
          value: `<p>En tanto, el <strong>${votosEnBlanco[0].votes_percent}%</strong> de los votos son en blanco y un 
            <strong>${votosNulos[0].votes_percent}%</strong> (*) corresponde a votos nulos.</p>`
        },
        {
          type: "text",
          value: `<p>En paralelo a las elecciones para Presidente y jefe de Gobierno, los porteños también debieron elegir 30 legisladores de la Ciudad (se renueva la mitad de la Legislatura) y las 15 Juntas Comunales.</p>`
        },
        {
          type: "text",
          value: `<p>* Este artículo fue generado de forma automática sobre la base de los datos oficiales provistos por la Dirección Nacional Electoral (DINE).</p>`
        },
        {
          _id: "12345678",
          type: "freehtml",
          value: {
            title: null,
            summary: null,
            name: "INFO_PAIS_Intención de voto por fórmulas para la presidencial",
            html: `<iframe class="elections-iframe" src="${params.urlIframe}" title="Intención de voto por fórmulas para la presidencial" scrolling="no" frameborder="0" data-external="1"></iframe>
              <script type="text/javascript" src="https://ecp.clarin.com/demo/js/iframeResizer.min.js"></script><script type="text/javascript">iFrameResize({checkOrigin:false,heightCalculationMethod:'documentElementOffset',});</script>`,
            htmlAmp: null
          }
        },
        {
          type: "text",
          value: `<hr class="separator" /><h2 class="read-more">Seguí leyendo</h2>`
        },
        {
          type: "text",
          value: `<h2 class="more-links"><a href="https://www.clarin.com/politica/pasa-voto-22-octubre_0_WoZDqEIlAu.html" target="_blank">
            Elecciones 2023: qué pasa si no voté</a></h2>`
        },
        {
          type: "text",
          value: `<h2 class="more-links"><a href="https://www.clarin.com/politica/multa-votar-dia-puede-pagar_0_Lh7yzMdp4G.html" target="_blank">
            De cuánto es la multa por no votar</a></h2>`
        },
        {
          type: "text",
          value: `<h2 class="more-links"><a href="https://www.clarin.com/politica/elecciones-2023-votos-necesitan-ganar-primera-vuelta_0_5GZaXJgLnt.html" target="_blank">
            Elecciones 2023: ¿cuántos votos se necesitan para ganar en primera vuelta?</a></h2>`
        }
      ],
      authors: [],
      sections: this.getSections(),
      metadata: this.getMetadata()
    };
  }

  /**
   * ALTERNATIVA 2: Post parcial (25-50% escrutado)
   */
  createPartialContent(data, params) {
    this.formatCandidates(data);
    const votosEnBlanco = this.extractStats(data.stats, "blank");
    const votosNulos = this.extractStats(data.stats, "annulled");
    const fechasFormateadas = convertirFecha(data.last_update);

    return {
      title: `Resultados Elecciones 2023 en Capital ${data.localidad}: quién es el candidato a Jefe de Gobierno más votado`,
      summary: `
        <ul>
          <li>Quién gana los comicios en CABA.</li>
          <li>Toda la información actualizada y el mapa electoral, minuto a minuto.</li>
        </ul>`,
      subtitle: "",
      description: "",
      publishedDate: "2023-10-22T19:05:00.000Z",
      formattedPublishedDate: "18 SEP 2023",
      lastModified: "Mon, 18 Sep 2023 23:01:20 GMT",
      gtmPublishedDate: "2023-09-18T",
      modificatedAt: fechasFormateadas,
      body: [
        {
          type: "text",
          value: `<p>En el marco de las Elecciones 2023 desarrolladas este domingo en la Ciudad de Buenos
            Aires, el candidato a Jefe de Gobierno porteño más votado en la ${data.localidad} es 
            <strong>${data.ganador.candidates[0].fullname}</strong>, de <strong>${data.ganador.name}</strong>, quien obtiene
            <strong>${data.ganador.votes}</strong> votos, que representan el <strong>${data.ganador.votes_percent}%</strong> de
            los votos, con el <strong>${data.mesasEscrutadas}</strong> por ciento de las mesas escrutadas.</p>`
        },
        {
          type: "text",
          value: `<p>En segundo lugar está <strong>${data.segundo.candidates[0].fullname}</strong>, de 
            <strong>${data.segundo.name}</strong>, que logra <strong>${data.segundo.votes}</strong> votos y el
            <strong>${data.segundo.votes_percent}%</strong> de los sufragios, mientras que en la tercera
            posición se encuentra <strong>${data.tercero.candidates[0].fullname}</strong>, de 
            <strong>${data.tercero.name}</strong>, con <strong>${data.tercero.votes}</strong> votos
            (<strong>${data.tercero.votes_percent}</strong> por ciento).</p>`
        },
        {
          type: "text",
          value: `<p>En tanto, el <strong>${votosEnBlanco[0].votes_percent}%</strong> de los votos son en blanco y un
            <strong>${votosNulos[0].votes_percent}%</strong> (*) corresponde a votos nulos.</p>`
        },
        {
          type: "text",
          value: `<p>En paralelo a las elecciones para Presidente y jefe de Gobierno, los porteños también
            debieron elegir 30 legisladores de la Ciudad (se renueva la mitad de la Legislatura) y las 15
            Juntas Comunales.</p>`
        },
        {
          type: "text",
          value: `<p>* Este artículo fue generado de forma automática sobre la base de los datos oficiales provistos por la Dirección Nacional Electoral (DINE).</p>`
        },
        {
          _id: "12345678",
          type: "freehtml",
          value: {
            title: null,
            summary: null,
            name: "INFO_PAIS_Intención de voto por fórmulas para la presidencial",
            html: `<iframe class="elections-iframe" src="${params.urlIframe}" title="Intención de voto por fórmulas para la presidencial" scrolling="no" frameborder="0" data-external="1"></iframe>
              <script type="text/javascript" src="https://ecp.clarin.com/demo/js/iframeResizer.min.js"></script><script type="text/javascript">iFrameResize({checkOrigin:false,heightCalculationMethod:'documentElementOffset',});</script>`,
            htmlAmp: null
          }
        },
        {
          type: "text",
          value: `<hr class="separator" /><h2 class="read-more">Seguí leyendo</h2>`
        },
        {
          type: "text",
          value: `<h2 class="more-links"><a href="https://www.clarin.com/politica/pasa-voto-22-octubre_0_WoZDqEIlAu.html" target="_blank">
            Elecciones CABA 2023: qué pasa si no voté</a></h2>`
        },
        {
          type: "text",
          value: `<h2 class="more-links"><a href="https://www.clarin.com/politica/multa-votar-dia-puede-pagar_0_Lh7yzMdp4G.html" target="_blank">
            De cuánto es la multa por no votar en CABA</a></h2>`
        }
      ],
      authors: [],
      sections: this.getSections(),
      metadata: this.getMetadata()
    };
  }

  /**
   * ALTERNATIVA 3: Post final (>50% escrutado)
   */
  createFinalContent(data, params) {
    this.formatCandidates(data);
    const votosEnBlanco = this.extractStats(data.stats, "blank");
    const votosNulos = this.extractStats(data.stats, "annulled");
    const fechasFormateadas = convertirFecha(data.last_update);
    
    // Lista dinámica de candidatos
    const candidatesList = this.buildCandidatesList(data);
    
    const title = data.localidad 
      ? `Resultados Elecciones 2023 en la ${data.localidad} de la Ciudad de Buenos Aires: quién es el candidato a Jefe de Gobierno más votado`
      : `Resultados Elecciones 2023 de la Ciudad de Buenos Aires: quién es el candidato a Jefe de Gobierno más votado`;

    return {
      title,
      summary: `
        <ul>
          <li>Quién gana los comicios en Capital este domingo 22 de octubre.</li>
          <li>Toda la información actualizada y el mapa electoral, minuto a minuto.</li>
        </ul>`,
      subtitle: "",
      description: "",
      publishedDate: "2023-10-22T19:05:00.000Z",
      formattedPublishedDate: "18 SEP 2023",
      lastModified: "Mon, 18 Sep 2023 23:01:20 GMT",
      gtmPublishedDate: "2023-09-18T",
      modificatedAt: fechasFormateadas,
      body: [
        {
          type: "text",
          value: `<p>En el marco de las Elecciones 2023 desarrolladas este domingo en la Ciudad de Buenos
            Aires, el candidato a Jefe de Gobierno porteño más votado ${data.localidad ? "en la" : ""} <strong>${data.localidad}</strong> es 
            <strong>${data.ganador.candidates[0].fullname}</strong>, de <strong>${data.ganador.name}</strong>, quien obtiene
            <strong>${data.ganador.votes}</strong> votos, que representan el <strong>${data.ganador.votes_percent}</strong> por ciento de las mesas escrutadas.</p>`
        },
        {
          type: "text",
          value: candidatesList
        },
        {
          type: "text",
          value: `<p>En paralelo a las elecciones para Presidente y jefe de Gobierno, los porteños también
            debieron elegir 30 legisladores de la Ciudad (se renueva la mitad de la Legislatura) y las 15
            Juntas Comunales.</p>`
        },
        {
          type: "text",
          value: `<p>* Este artículo fue generado de forma automática sobre la base de los datos oficiales provistos por la Dirección Nacional Electoral (DINE).</p>`
        },
        {
          _id: "12345678",
          type: "freehtml",
          value: {
            title: null,
            summary: null,
            name: "INFO_PAIS_Intención de voto por fórmulas para la presidencial",
            html: `<iframe class="elections-iframe" src="${params.urlIframe}" title="Intención de voto por fórmulas para la presidencial" scrolling="no" frameborder="0" data-external="1"></iframe>
              <script type="text/javascript" src="https://ecp.clarin.com/demo/js/iframeResizer.min.js"></script><script type="text/javascript">iFrameResize({checkOrigin:false,heightCalculationMethod:'documentElementOffset',});</script>`,
            htmlAmp: null
          }
        },
        {
          type: "text",
          value: `<hr class="separator" /><h2 class="read-more">Seguí leyendo</h2>`
        },
        {
          type: "text",
          value: `<h2 class="more-links"><a href="https://www.clarin.com/politica/pasa-voto-22-octubre_0_WoZDqEIlAu.html" target="_blank">
            Elecciones 2023, Ciudad de Buenos Aires: qué pasa si no voté</a></h2>`
        },
        {
          type: "text",
          value: `<h2 class="more-links"><a href="https://www.clarin.com/politica/multa-votar-dia-puede-pagar_0_Lh7yzMdp4G.html" target="_blank">
            CABA: de cuánto es la multa por no votar</a></h2>`
        }
      ],
      authors: [],
      sections: this.getSections(),
      metadata: this.getMetadata()
    };
  }

  /**
   * Helpers específicos de Jefe de Gobierno
   */
  formatCandidates(data) {
    const propiedades = ["ganador", "segundo", "tercero", "cuarto", "quinto"];
    propiedades.forEach(prop => {
      if (data[prop]) {
        data[prop].votes = formatWithCommas(data[prop].votes);
        data[prop].votes_percent = roundToTwoDecimals(data[prop].votes_percent);
      }
    });
    data.mesasEscrutadas = roundToTwoDecimals(data.mesasEscrutadas);
  }

  extractStats(stats, type) {
    const result = stats?.filter(item => item.type === type) || [];
    if (result[0]) {
      result[0].votes_percent = roundToTwoDecimals(result[0].votes_percent);
    }
    return result;
  }

  buildCandidatesList(data) {
    let candidatesList = "<ol>";

    const positions = ['ganador', 'segundo', 'tercero', 'cuarto', 'quinto'];
    
    positions.forEach(position => {
      if (data[position]?.candidates?.length > 0) {
        candidatesList += `<li>${data[position].candidates[0].fullname}, de ${data[position].name}, con ${data[position].votes} y el ${data[position].votes_percent}% de los votos</li>`;
      }
    });

    return candidatesList + "</ol>";
  }

  getRelatedLinks() {
    return [
      {
        type: "text",
        value: `<hr class="separator" /><h2 class="read-more">Seguí leyendo</h2>`
      },
      {
        type: "text",
        value: `<h2 class="more-links"><a href="https://www.clarin.com/politica/pasa-voto-22-octubre_0_WoZDqEIlAu.html" target="_blank">
          Elecciones 2023: qué pasa si no voté</a></h2>`
      },
      {
        type: "text",
        value: `<h2 class="more-links"><a href="https://www.clarin.com/politica/multa-votar-dia-puede-pagar_0_Lh7yzMdp4G.html" target="_blank">
          De cuánto es la multa por no votar</a></h2>`
      }
    ];
  }

  getSections() {
    return [
      {
        _id: 15006,
        name: "Información General",
        url: "informacion-general",
        nsSite: "",
        autoplay: false,
        metadata: {}
      }
    ];
  }

  getMetadata() {
    return {
      typeWeb: "small",
      origin: "default",
      payWallAccessControl: "freemium",
      sponsored: false,
      accessProduct: "CLARIN_D",
      canHaveAmp: true,
      canHaveComments: true,
      autoRefresh: true,
      titleEnable: false,
      footer_visible: true,
      ualterDisabled: false,
      trinityDisabled: false,
      disabledTimelineLiveblog: false,
      featuredContent: false,
      stopWords: true
    };
  }

  getTags(params) {
    return [
      { 
        name: `Elecciones ${params.year || 2023}`, 
        slug: `elecciones-${params.year || 2023}`, 
        subject: "subject", 
        _id: "VyFmuMo-2" 
      },
      { 
        name: "Jefe de Gobierno", 
        slug: "jefe-de-gobierno", 
        subject: "subject" 
      },
      {
        name: "Ciudad de Buenos Aires",
        slug: "ciudad-de-buenos-aires",
        subject: "subject"
      }
    ];
  }

  generateMeta(content, data, params) {
    const title = content?.title || `Elecciones Jefe de Gobierno ${params.year || 2023} - CABA`;
    const description = this.extractDescription(content) || 
                       `Resultados elecciones a Jefe de Gobierno en Ciudad de Buenos Aires`;
    const imageUrl = this.getImage(params.codeLetter);

    return {
      description,
      title,
      keywords: `Jefe de Gobierno, CABA, Ciudad de Buenos Aires, Elecciones ${params.year || 2023}, Resultados`,
      url: params.baseUrl,
      urlImage: imageUrl,
      extra: [
        { name: "title", content: title },
        { name: "description", content: description },
        { name: "distribution", content: "global" },
        { name: "robots", content: "max-image-preview:large" },
        { property: "og:image", content: imageUrl },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "article:published_time", content: `${params.year || 2023}-10-22T19:05:00.000Z` },
        { property: "article:modified_time", content: data.last_update }
      ]
    };
  }

  extractDescription(content) {
    return content?.description || 
           content?.body?.[0]?.value?.replace(/<[^>]*>/g, '')?.trim();
  }
}